/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import { ucwords } from '../helper';
import * as actions from '../actions';
import * as c from '../constant';

function BusinessActivityCreateModal({
  formData,
  getBusinessNaturesList,
  businessNaturesList,
  getBusinessLinesList,
  businessLinesList,
  getNecessaryFieldsList,
  necessaryFieldsList,
  setFormData,
  closeModal,
  handleOnCreate,
}) {
  const validateForm = useFormValidator(formData, {
    business_nature_id: 'required',
    business_line_id: 'required',
    capital_amount: 'required',
    gross_amount: 'required',
  });

  useEffect(() => {
    getBusinessNaturesList();
    setFormData({
      business_nature_id: '',
      business_line_id: '',
      capital_amount: '',
      gross_amount: '',
    });
  }, []);

  const handleNatureDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getBusinessLinesList({ business_nature_id: e.value });
  };

  const selectBusinessNatureId = businessNaturesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleLineDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getNecessaryFieldsList({ business_line_id: e.value });
  };

  const selectBusinessLineId = businessLinesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleOfficeTypeDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const selectOptions = list => {
    const newList = [];

    list.map(data => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, x => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const handleOnChange = key => e => {
    if (e.target.value && /^\d{1,}(\.\d{0,4})?$/.test(e.target.value)) {
      setFormData({
        ...formData,
        [_.get(e, "target.name")]: _.get(e, "target.value"),
      });
    }
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const onBlurDecimal = (e) => {
    setFormData({
      ...formData,
      [_.get(e, "target.name")]: parseFloat(_.get(e, "target.value")),
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  return (
    <div>
      <div className="row">
        <div className="col-6 form-group">
          <label className="form-label">
            Business Nature:
            {validateForm.renderMessage('business_nature_id')}
          </label>
          <Select
            options={selectBusinessNatureId}
            placeholder="Select Business Nature"
            onChange={handleNatureDropDownChange('business_nature_id')}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">
            Business Line:
            {validateForm.renderMessage('business_line_id')}
          </label>
          <Select
            options={selectBusinessLineId}
            placeholder="Select Business Line"
            onChange={handleLineDropDownChange('business_line_id')}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">
            Capital Amount:
            {validateForm.renderMessage('capital_amount')}
          </label>
          <input
            className="form-control"
            type="number"
            name="capital_amount"
            onChange={handleOnChange('capital_amount')}
            value={_.get(formData, 'capital_amount')}
            onBlur={onBlurDecimal}
          />
        </div>
        {/* <div className="col-6 form-group">
          <label className="form-label">
            Gross Amount:
            {validateForm.renderMessage('gross_amount')}
          </label>
          <input
            className="form-control"
            type="number"
            name="gross_amount"
            onChange={handleOnChange('gross_amount')}
            value={_.get(formData, 'gross_amount')}
            onBlur={onBlurDecimal}
          />
        </div> */}
        <div className="col-12 form-group">
          {necessaryFieldsList.map(item => {
            return (
              <div key={item.id}>
                <div>
                  {_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}
                      </label>
                      <Select
                        onChange={handleOfficeTypeDropDownChange(
                          _.get(item, 'multiplier')
                        )}
                        options={selectOptions(_.get(item, 'options'))}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group">
                  {!_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}
                      </label>
                      <input
                        className="form-control"
                        name={_.get(item, 'label')}
                        id={_.get(item, 'label')}
                        onChange={handleOnChange(_.get(item, 'multiplier'))}
                        value={_.get(formData, _.get(item, 'multiplier'))}
                        required
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex justify-content-end pb-3">
        <button
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          onClick={handleOnCreate(formData)}
        >
          <span className="font-weight-bold">Add</span>
        </button>
        <button
          type="button"
          onClick={() => closeModal()}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
    </div>
  );
}

BusinessActivityCreateModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  getBusinessNaturesList: PropTypes.instanceOf(Function).isRequired,
  businessNaturesList: PropTypes.instanceOf(Array).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,
  handleOnCreate: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessNaturesList: _.get(api, `${c.GET_BUSINESS_NATURES_LIST}.list`) || [],
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BusinessActivityCreateModal);
